<script lang="ts">
    import ElencoEventi from "./ElencoEventi.svelte";
</script>

<div class="row">
    <strike>sgabuzzino di Massimo</strike>
    <h1>Piazza Colombo</h1>
</div>

<div class="row"><h2>Descrizione</h2></div>
<div class="row">
    <div class="col-sm-12 col-md-6">
        <p>
            Sito personale per coordinare eventi tra amici; NON è collegato al progetto appröu.
        </p>
        <p>
            Esiste solo per aiutarmi a organizzare le serate durante queste
            lunghe quarantene, coordinando le persone e inserendo le ultime
            informazioni in UN solo posto
        </p>
    </div>
    <div class="col-sm-6 col-md-3">
        <img src="/favicon.png" alt="meme torpedine" />
    </div>
    <div class="col-sm-6 col-md-3">
        <img src="/static/piazzacolombo_albero.jpg" alt="piazza colombo" />
    </div>
</div>

<div class="row">
    <div class="col-sm-12"><hr /></div>
</div>
<div class="row">
    <div class="col-sm-12">
        <ElencoEventi />
    </div>
</div>

<style>
    img {
        max-height: 15em;
    }
</style>
